import { byId, el } from './dom.js';

/** Prepend a log line; keep the 30 most recent (prototype behavior). */
export function appendLog(msg: string, important: boolean): void {
  const box = byId('log');
  box.prepend(el('div', { className: important ? 'important' : '', text: msg }));
  while (box.children.length > 30) box.lastChild?.remove();
}
